import React, {useState, useEffect , useRef} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from 'layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import {API_ENDPOINT, toast_anim } from 'components/config/Common'
import {Loading , WalletPointsIcon} from "components/custom-icons";

import axios from 'axios';  
import {APP_URL, APP_NAME , IMG_URL , LIMIT , amount_format} from 'components/config/Common'

import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from 'components/ui/ScrollPageTop'
import {Links} from 'routes/PathLink'

import { Pagination, Select } from "antd";
import { Table } from "components/ui/table";
import Button from 'components/ui/Button.tsx'
import {
  useUserScreensQuery, useDeleteScreenMutation,
} from 'data/dashboard-data';

import ModalView from '_utils/ModalView'
import Seo from 'components/seo/seo'
import { use } from "i18next";


const MyScreens = () => {
	
	const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
	
	//const [forums,setForums]= useState([]);
	
  const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
    const [orderBy, setOrder] = useState('created_at');
    const [sortedBy, setColumn] = useState('desc');
  const [open, setOpen] = useState(false);
  const [screenId, setScreenId] = useState(null);

  useEffect(() => {
    
    // Fetch screens when component mounts or page/pageSize/orderBy/sortedBy changes
  }, [page, pageSize, orderBy, sortedBy]);

	const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }

  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }

  const {
      screens,      
      paginatorInfo,
      isLoading,
      error,
    } = useUserScreensQuery({       
      limit: pageSize,
      page,    
      orderBy,
      sortedBy,
    });
	
    //console.log("Screens Data ",screens)

    const {mutate: deleteScreenMutation} = useDeleteScreenMutation(screenId);


	const siteMetadata = {
		url: `${APP_URL}/profile`,
		title:  `My wallet - ${APP_NAME}`,
		description: `My wallet - ${APP_NAME}`,
	}
    
    const skeleton = Array.from({ length: pageSize }, (_, i) => ({
        id: `sk-${i}`,
        _isSkeleton: true
        }));
    
        const columns = [
            {
              title: 'Sr.No.',
              dataIndex: 'srno',
              key: 'id',
              align: 'left',
              width: 50,
              render: (text, record, index) => {
                return index+1
            },
            },
            {
              title: 'Title',
              dataIndex: 'name',
              key: 'name',
              align: 'left',
              width: 200,
              render:(name,record) =>{
                  let path = `${record.id}`;
                  
    
                 return (<div
                  className="overflow-hidden truncate whitespace-nowrap text-wrap" >
                   
                    <Link className="text-accent" target="_blank" to={`${process.env.REACT_APP_URL}${Links.SCREENS}/${record?.slug}`}><span className="text-sm">{record?.title}</span></Link>
                    <div className="mt-3">
                    {record?.is_public ?  
                    <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20">
                        Public
                    </span>
                    : 
                    <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/10">
                        Private
                    </span>
                    }
                    </div>    
                             
                </div>)
                }
            },
            
            {
              title: 'Description',
              dataIndex: 'content',
              key: 'content',
              align: 'left',
              width: 200,
              render:(name,record) =>(
                <>{<div>{record?.description}</div>}</>
              )
            },
            {
              title: 'Query',
              dataIndex: 'userQuery',
              key: 'userQuery',
              align: 'left',
              width: 50,
              render:(name,record) =>(
                <>{<div>{record?.userQuery}</div>}</>
              )
            },
            {
              title: 'Followers',
              dataIndex: 'followers_count',
              key: 'followers_count',
              align: 'left',
              width: 50,
              render:(name,record) =>(
                <>{<div>{record?.followers_count}</div>}</>
              )
            },
            {
              title: 'Actions',
              dataIndex: 'followers_count',
              key: 'followers_count',
              align: 'left',
              width: 50,
              render:(name,record) =>(
                <div>
                    <Button onClick={() => openDeleteModal(record?.id)} size="small" className="text-sm text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg px-3 py-1.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Delete</Button>

                </div>
              )
            },
        ];
        
const deleteScreen = () => {
  //setOpen(true);
  //console.log("Delete Screen Id ",screenId)
  deleteScreenMutation(screenId, {
    onSuccess: (data) => {
      //console.log("Screen Deleted Successfully ",data);
      setOpen(false);
    toast.success("Screen deleted successfully!", toast_anim);
    },
    onError: (error) => {
      console.log("Error Deleting Screen ",error);
      toast.error("Error deleting screen. Please try again.", toast_anim);
    },
  });
}
  

const openDeleteModal = (screenId) => {
  setOpen(true);
  setScreenId(screenId);
}
        



	return (
		<ScrollPageTop>
        <Seo 
          title={`My Screens - ${APP_NAME}`}
          desc={`My Screens - ${APP_NAME}`}
          url={`${APP_URL}/my-screens`}
        />
         <LeftMenuLayout> 
				<div className="w-full ">
					<div className={classNames('bg-white w-full shadow rounded mb-8')}>
						{/*<p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Welcome You are logged In.</p>*/}
						
						<h2 className="text-2xl font-semibold p-8">My Screens</h2>

						<Table            
                columns={columns}
                rowKey="id"
                data={isLoading ? skeleton : screens}
                scroll={{ x: 900 }}
                
                rowClassName={(record, index) => {
                    if (record._isSkeleton) {
                        // Animate only alternate skeleton rows (even rows)
                        return index % 2 === 0
                        ? "skeleton-row pulse-row"
                        : "skeleton-row-odd";
                    }

                    if (record._isHeader) return "repeat-header";

                    return "";
                }}
            />
            <div className="w-full flex justify-start mb-5 p-5">
                {!!paginatorInfo?.total && ( 
                <div className="w-full flex items-left justify-between flex-wrap">
                    <div>
                    <Pagination
                    total={paginatorInfo.total}
                    current={paginatorInfo.currentPage}
                    pageSize={paginatorInfo.perPage}
                    onChange={onPagination}
                    showSizeChanger={false}
                    className="flex-wrap"
                    />
                    </div>
                    <div className="flex items-center justify-center">
                        <div className="px-5 text-sm text-gray-500">Results Per Page</div>
                        <Select
                            value={pageSize}
                            onChange={onPageSize}
                            options={[
                                { value: 10, label: "10 rows" },
                                { value: 25, label: "25 rows" },
                                { value: 50, label: "50 rows" },
                                { value: 100, label: "100 rows" },
                                
                            ]}
                            style={{ width: 130 }}
                        />
                    </div>
                </div>
                )} 
            </div>
					</div>
				</div>
		</LeftMenuLayout> 
    <ModalView open={open} onClose={() => setOpen(false)}>
        <div className="flex flex-col justify-center p-6">
            <h2 className="text-2xl font-semibold mb-4">Delete Screen</h2>
            <p className="mb-6">Are you sure you want to delete this screen? This action cannot be undone.</p>
            <div className="flex justify-end space-x-4">
                <Button size="small" variant="outline"  onClick={() => setOpen(false)}>Cancel</Button>
                <Button size="small" className="bg-red-500 text-white hover:bg-red-600" onClick={() => deleteScreen()}>Delete</Button>
            </div>
        </div>                     
    </ModalView>
      </ScrollPageTop>
   );
};

export default MyScreens;